import classNames from "classnames";
import React from "react";
import {Link} from 'react-scroll';
import styles from "./SpyNav.module.scss"

export default ({names, className, style, offset = -250, duration = 500, hashSpy = true, ...rest}) => {
    return (<div style={style} className={classNames(styles["sidebar"], className)}>
        <div className={classNames(styles["links"])}>
            {names && names.map((name, index) => {
                return <React.Fragment key={index}>
                    <Link className={classNames(styles["link"])} activeClass={styles["active-link"]}
                          to={hashSpy ? names[index] : index.toString()}
                          spy={true}
                          smooth={true}
                          offset={offset}
                          duration={duration}
                          hashSpy={hashSpy}
                          {...rest}>
                        {names[index]}
                    </Link>
                    <div className={classNames(styles["line"])}></div>
                </React.Fragment>
            })}
                </div>
                </div>)
            }

